<button [class]="colorClass()" [class]="shapeClass()" type="button">
    <fa-icon [icon]="icon"></fa-icon>
</button>